import React, { useState } from 'react'

import { Box, Display, AlignItems, DisplayPosition, Overflow } from '@gousto-internal/citrus-react'

import { ALL_PRODUCTS_CATEGORY_ID } from 'routes/OrderConfirmation/constants/categories'
import type { NavigationCategory } from 'routes/OrderConfirmation/types/navigationCategory'

import { CategoryButton } from './CategoryButton'
import { ScrollArrow } from './ScrollArrow'
import { useScrollState } from './useScrollState'

type ProductsNavBarProps = {
  categories: Record<string, NavigationCategory>
  onSelectCategory: (id: string) => void
}

const getDefaultCategoryId = (categories: Record<string, NavigationCategory>) =>
  categories[ALL_PRODUCTS_CATEGORY_ID].id

export const ProductsNavBar = ({ categories, onSelectCategory }: ProductsNavBarProps) => {
  const defaultCategoryId = getDefaultCategoryId(categories)
  const [selectedCategoryId, setSelectedCategoryId] = useState(defaultCategoryId)

  const { scrollRef, containerRef, hasOverflow, atStart, atEnd, scrollLeft, scrollRight } =
    useScrollState()

  const handleSelectCategory = (id: string) => {
    setSelectedCategoryId(id)
    onSelectCategory(id)
  }

  return (
    <Box
      data-testid="MarketProductsNavBar"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      position={DisplayPosition.Relative}
      ref={containerRef}
    >
      {hasOverflow && !atStart && <ScrollArrow direction="left" onClick={() => scrollLeft()} />}
      <Box
        ref={scrollRef}
        display={Display.Flex}
        gap={5}
        flexGrow={1}
        overflowX={Overflow.Scroll}
        style={{
          scrollBehavior: 'smooth',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {Object.keys(categories).map((categoryId) => {
          const { id, label, count } = categories[categoryId]
          const isActive = id === selectedCategoryId

          return (
            <CategoryButton
              key={id}
              count={count}
              id={id}
              isActive={isActive}
              label={label}
              onClick={handleSelectCategory}
            />
          )
        })}
      </Box>
      {hasOverflow && !atEnd && <ScrollArrow direction="right" onClick={() => scrollRight()} />}
    </Box>
  )
}
